import React, { useEffect, useRef } from 'react';
import { animate, useInView } from 'framer-motion';

const stats = [
  { value: 340, suffix: '+', label: 'Weddings photographed' },
  { value: 12, suffix: '', label: 'Years behind the lens' },
  { value: 26, suffix: '', label: 'Countries travelled' },
  { value: 98, suffix: '%', label: 'Couples who refer us' },
];

function StatNumber({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: 'easeOut',
      onUpdate: (latest) => {
        if (ref.current) ref.current.textContent = Math.round(latest).toString();
      },
    });
    return () => controls.stop();
  }, [inView, value]);

  return <span ref={ref}>0</span>;
}

function Stats() {
  return (
    <section className="stats section-wrap">
      {stats.map((stat) => (
        <div className="stat" key={stat.label}>
          <div className="stat-number">
            <StatNumber value={stat.value} />
            {stat.suffix && <sup>{stat.suffix}</sup>}
          </div>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </section>
  );
}

export default Stats;
